import axios from 'axios';

import { buildEndpoint } from '@services/service';

const BASE_URL = process.env.REACT_APP_AUTH_URL as string;

const generateToken = async (scopes?: string[]): Promise<string | null> => {
    try {
        const credentials: Record<string, string> = {
            clientId: process.env.REACT_APP_OAUTH_CLIENT_ID as string,
            clientSecret: process.env.REACT_APP_OAUTH_CLIENT_SECRET as string,
        };
        if (scopes && scopes.length > 0) {
            credentials['scopes'] = scopes.join(' ');
        }
        const url = buildEndpoint(BASE_URL, 'api/v2/oauth/token');
        const response = await axios.post(url.toString(), credentials);
        return response.data.accessToken;
    } catch (err) {
        return null;
    }
};

export { generateToken };
